<template>
  <div>
    <h3>売上情報</h3>

    <!-- searh filters -->
    <v-card color="grey-lighten-5" class="mt-2" variant="flat">
      <v-container>
        <v-row>
          <v-spacer />
          <v-col cols="3">
            <h5>開始月</h5>
            <v-text-field
              v-model="searchFilter.monthFrom"
              variant="outlined"
              density="compact"
              hide-details
              type="month"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <h5>終了月</h5>
            <v-text-field
              v-model="searchFilter.monthTo"
              variant="outlined"
              density="compact"
              hide-details
              clearable
              type="month"
            ></v-text-field>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="4">
            <v-btn
              @click="listSales"
              :loading="loading"
              color="primary"
              variant="flat"
              block
              >検索</v-btn
            >
          </v-col>
          <v-spacer />
        </v-row>
      </v-container>
    </v-card>

    <!-- tables -->
    <div class="pt-4">
      <v-table>
        <thead>
          <tr>
            <th>項目名</th>
            <th></th>
            <th v-for="(item, i) in sales" :key="i">
              {{ `${item.year}/${item.month}` }}
            </th>
          </tr>
        </thead>
        <tbody v-if="sales">
          <!-- photo && data -->
          <tr>
            <td>写真データ</td>
            <td>アップロード数</td>
            <td v-for="(item, i) in sales" :key="i">
              {{
                item.sales.find(
                  (s) => s.mediaCategory == "photo" && s.mediaFormat == "data"
                ).unitOfUpload
              }}
            </td>
          </tr>

          <tr>
            <td></td>
            <td>売上本数</td>
            <td v-for="(item, i) in sales" :key="i">
              {{
                item.sales.find(
                  (s) => s.mediaCategory == "photo" && s.mediaFormat == "data"
                ).unitOfSales
              }}
            </td>
          </tr>
          <tr>
            <td></td>
            <td>売上金額</td>
            <td v-for="(item, i) in sales" :key="i">
              <strong>
                {{
                  item.sales.find(
                    (s) => s.mediaCategory == "photo" && s.mediaFormat == "data"
                  ).price + "円"
                }}
              </strong>
            </td>
          </tr>

          <!-- photo && print -->
          <tr>
            <td>写真プリント</td>
            <td>アップロード数</td>
            <td v-for="(item, i) in sales" :key="i">
              {{
                item.sales.find(
                  (s) => s.mediaCategory == "photo" && s.mediaFormat == "print"
                ).unitOfUpload
              }}
            </td>
          </tr>

          <tr>
            <td></td>
            <td>売上本数</td>
            <td v-for="(item, i) in sales" :key="i">
              {{
                item.sales.find(
                  (s) => s.mediaCategory == "photo" && s.mediaFormat == "print"
                ).unitOfSales
              }}
            </td>
          </tr>
          <tr>
            <td></td>
            <td>売上金額</td>
            <td v-for="(item, i) in sales" :key="i">
              <strong>
                {{
                  item.sales.find(
                    (s) =>
                      s.mediaCategory == "photo" && s.mediaFormat == "print"
                  ).price + "円"
                }}
              </strong>
            </td>
          </tr>

          <!-- movie && data -->
          <tr>
            <td>動画データ</td>
            <td>アップロード数</td>
            <td v-for="(item, i) in sales" :key="i">
              {{
                item.sales.find(
                  (s) => s.mediaCategory == "movie" && s.mediaFormat == "data"
                ).unitOfUpload
              }}
            </td>
          </tr>

          <tr>
            <td></td>
            <td>売上本数</td>
            <td v-for="(item, i) in sales" :key="i">
              {{
                item.sales.find(
                  (s) => s.mediaCategory == "movie" && s.mediaFormat == "data"
                ).unitOfSales
              }}
            </td>
          </tr>
          <tr>
            <td></td>
            <td>売上金額</td>
            <td v-for="(item, i) in sales" :key="i">
              <strong>
                {{
                  item.sales.find(
                    (s) => s.mediaCategory == "movie" && s.mediaFormat == "data"
                  ).price + "円"
                }}
              </strong>
            </td>
          </tr>
        </tbody>
      </v-table>
    </div>
  </div>
</template>

<script lang="ts">
import LocalDataService from "@/service/LocalDataService";
import { memoruModule } from "@/store/dataModules/memoruModule";
import { MemoruSalesListResponse } from "chaild-api/lib";
import dayjs from "dayjs";
import { defineComponent } from "vue";

export default defineComponent({
  name: "MemoruSales",

  async mounted() {
    this.searchFilter.monthTo = dayjs().format("YYYY-MM");
    this.searchFilter.monthFrom = dayjs()
      .subtract(2, "month")
      .format("YYYY-MM");
    await this.listSales();
  },

  data() {
    return {
      loading: false,
      searchFilter: {
        monthTo: "",
        monthFrom: "",
      },
    };
  },

  computed: {
    sales: function (): MemoruSalesListResponse | null {
      return memoruModule.sales;
    },
  },

  methods: {
    async listSales() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await memoruModule
          .listSales({
            nurseryId,
            ...this.searchFilter,
          })
          .catch(() => (this.loading = false));
      }
      this.loading = false;
    },
  },
});
</script>
